import * as actionTypes from 'actions/actionTypes';
import { generateConsents } from 'utils/helpers';

export const getMarketingConsents = (consentToAppend) => ({
  types: [
    actionTypes.GET_MARKETING_CONSENTS,
    actionTypes.GET_MARKETING_CONSENTS_SUCCESS,
    actionTypes.GET_MARKETING_CONSENTS_FAIL,
  ],
  data: { consentToAppend },
  promise: (client) => client.get(
    `${API_HOST}/customer/marketing-consent`,
    { hideError: true }
  ),
});

export const putMarketingConsents = (storeState, data, afterSuccess = (() => {})) => {
  const {
    marketingConsents = [],
    intl: { locale = '' } = {},
  } = storeState;
  const requestBody = generateConsents(marketingConsents, data, locale);
  return {
    data,
    types: [
      actionTypes.PUT_CONSENTS,
      actionTypes.PUT_CONSENTS_SUCCESS,
      actionTypes.PUT_CONSENTS_FAIL,
    ],
    promise: (client) => client.put(
      `${API_HOST}/customer/marketing-consent`,
      requestBody
    ),
    afterSuccess: () => {
      if (typeof afterSuccess === 'function') {
        afterSuccess();
      }
    },
  };
};
